import React from "react";

const Invite: React.FC = () => {
  return (
    <svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3333 14C8.55775 14 5.33325 14.597 5.33325 16.9892C5.33325 19.3804 8.53712 20 12.3333 20C16.1088 20 19.3333 19.402 19.3333 17.0108C19.3333 14.6196 16.1294 14 12.3333 14Z"
        stroke="#101111"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3333 11C14.5539 11 16.3333 9.21979 16.3333 7C16.3333 4.77933 14.5539 3 12.3333 3C10.1135 3 8.33325 4.77933 8.33325 7C8.33325 9.21979 10.1135 11 12.3333 11Z"
        stroke="#101111"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3333 9V13"
        stroke="#101111"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.3333 11H19.3333"
        stroke="#101111"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Invite;
